import { styled } from 'styled-components'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import theme from '../../../Theme'
import { Menu, MenuItem } from '@mui/material'

export const StyledHeader = styled(Box) <{ isMobile: boolean, isHeaderColor: string | null }>`
  position: relative;
  display: grid;
  align-items: center;
  justify-items: center;
  height: ${theme.spacing(16)};
  border-radius: ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(0)} ${theme.spacing(0)};
  background: white;
  border-bottom: solid 1px #D7D8D9;
`

export const StyledIconButton = styled(IconButton)`
  align-items: center; 
  justify-content: center;
  color: #283036 !important;  
  &:hover {
    background-color: transparent !important;
  }
  &.expandMinimizeButton {
    position: absolute;
    left: ${theme.spacing(0)};
  }
  &.hamburgerMenuButton {
    position: absolute;
    left: ${theme.spacing(2)};
  }
`

export const StyledMesssageImageWrapper = styled(Box)`
  flex: 1;
  text-align: center;
`

export const StyledMesssageImage = styled.img<{ isMobile: boolean }>`
  height: ${`${theme.spacing(8)}`};
`

export const StyledHeaderButtonsGroup = styled(Box)`
  position: absolute !important;
  right: 0;
  height: 100%;
  align-content: center;
`

export const StyledLabelHeaderWrapper = styled(Box)`
  max-width: calc(70% - ${theme.spacing(21)});
  flex: 1;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: ${theme.spacing(4)};
  font-weight: 500;
  color: #283036;
  white-space: nowrap;
`

export const StyledMenu = styled(Menu)`
  border: 1px solid #E0E2E2;
  border-radius: ${theme.spacing(2)};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  z-index: 20;
  &.styledMenu {
    padding: 0;
  }
`

export const StyledMenuItem = styled(MenuItem)`
  width: 100%;
  display: flex;
  padding: ${theme.spacing(2)} ${theme.spacing(3)};
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.95rem;
  &:hover {
    background: #f5f5f5;
  }
  & > svg {
    margin-right: 0.25rem;
    height: 1rem;
  }
  &.deleteMenuItem {
    color: red;
    & > svg {
      color: red;
    }
 }
`

export const StyledInput = styled.input`
  max-width: calc(70% - ${theme.spacing(21)});
  flex-grow: 1;
  text-align: center;
  background: transparent;
  border: none;
  color: inherit;
  font: inherit;
  padding: 4px 0px;
  margin: 0;
  &:focus {
    outline: none;
    border: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    color: #888;
    opacity: 1;
  }
`

